import { render, staticRenderFns } from "./ActivitySplitButton.vue?vue&type=template&id=0a88fa19&scoped=true&"
import script from "./ActivitySplitButton.vue?vue&type=script&lang=js&"
export * from "./ActivitySplitButton.vue?vue&type=script&lang=js&"
import style0 from "./ActivitySplitButton.vue?vue&type=style&index=0&id=0a88fa19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a88fa19",
  null
  
)

export default component.exports